import React from 'react';
import { 
  ExternalLink, 
  Shirt, 
  Sticker, 
  Layers, 
  Pin, 
  Magnet,
  Sun,
  Snowflake,
  ShoppingBag,
  Maximize2,
  ThermometerSun
} from 'lucide-react';

const MerchandiseSection = () => {
  // Merchandise categories with icons and links to third-party site
  const merchCategories = [
    {
        id: 1,
        name: 'Tank Top',
        icon: <ThermometerSun size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
        url: 'https://www.teepublic.com/user/adelaide-encontro/tank-top?sort=newest'
      },
    {
      id: 2,
      name: 'T-shirts',
      icon: <Shirt size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro'
    },
    {
      id: 3,
      name: 'Long Sleeve Tees',
      icon: <Maximize2 size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/long-sleeve-t-shirt'
    },
    {
      id: 4,
      name: 'Crew Neck Sweaters',
      icon: <Layers size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/crewneck-sweatshirt'
    },
    {
      id: 5,
      name: 'Hoodies',
      icon: <Snowflake size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/hoodie'
    },
    {
      id: 6,
      name: 'Hats',
      icon: <Sun size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/hats'
    },
    {
      id: 7,
      name: 'Tote Bags',
      icon: <ShoppingBag size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/totes'
    },
    {
      id: 8,
      name: 'Pins',
      icon: <Pin size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/pins'
    },
    {
      id: 9,
      name: 'Stickers',
      icon: <Sticker size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/stickers'
    },
    {
      id: 10,
      name: 'Magnets',
      icon: <Magnet size={36} className="text-[#2E0854] group-hover:text-[#FF4500]" />,
      url: 'https://www.teepublic.com/user/adelaide-encontro/magnets'
    }
  ];

  return (
    <section id="merchandise" className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-lg mb-12 max-w-3xl mx-auto">
          Take home a piece of the Samba Encontro 2025 experience with our official merchandise.
          Available through our Tee Public store.
        </p>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
          {merchCategories.map((category) => (
            <a 
              key={category.id} 
              href={category.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 group p-4 text-center h-40 flex flex-col items-center justify-center"
            >
              <div className="mb-3 transition-transform duration-300 group-hover:scale-110">
                {category.icon}
              </div>
              
              <h3 className="text-base font-bold mb-1 text-[#2E0854] group-hover:text-[#FF4500] transition-colors duration-300">{category.name}</h3>              
              <div className="mt-auto pt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center text-xs text-[#FF4500]">
                Shop Now <ExternalLink className="ml-1" size={12} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MerchandiseSection;